import { useAuth0 } from '@auth0/auth0-react';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import { Redirect, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    Grid,
    LinearProgress,
    Modal,
    styled,
    TextField,
    Typography,
    Paper,
} from '@mui/material';
import React, { useState } from 'react';
import axios from 'axios';
import { addNetworkToSchool } from '../../redux/SchoolSlice';
import NetworkSchool from './NetworkSchool';
//import NetworkInvite from './NetworkInvite';
import NetworkRequest from './NetworkRequest';
const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

const GeneralText = styled(TextField)(({ theme }) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: '0.5%',
    marginRight: '0.5%',
    width: '97%',
}));

export const Network = props => {
    const dispatch = useDispatch();
    const { getAccessTokenSilently } = useAuth0();
    const [createNetworkDisabled, setCreateNetworkDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [networkName, setNetworkName] = useState('');

    const school = useSelector(state => state.school.school.Data);
    const profile = useSelector(state => state.profile.profile.Data.Items[0]);
    // console.log('--------------', school, profile);

    const changeNetworkName = event => {
        event.preventDefault();
        const network = event.target.value;
        setNetworkName(network);
        if (network.length > 3) {
            setCreateNetworkDisabled(false);
        } else {
            setCreateNetworkDisabled(true);
        }
    };

    const createNetwork = event => {
        setLoading(true);
        setCreateNetworkDisabled(true);

        async function addToSchool() {
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            const requestData = {
                'token': token,
                'request': { 'networkName': networkName },
            };
            const outcome = await dispatch(addNetworkToSchool(requestData));
            console.log('outcome', outcome);
            if (typeof outcome.error?.message !== 'undefined') {
                throw new Error('Failed to add network');
            }
        }
        addToSchool()
            .then(i => {
                props.setNotif('success', 3000, 'Added new network');
                setLoading(false);
            })
            .catch(err => {
                props.setNotif('error', 6000, 'Failed to add network');
                setLoading(false);
                setCreateNetworkDisabled(false);
            });
    };

    const handleKeyDown = event => {
        if (event.key === 'Enter' && !createNetworkDisabled) {
            createNetwork(event);
        }
    };
    const handleFormSubmit = event => {
        event.preventDefault();

        if (!createNetworkDisabled) {
            createNetwork(event);
        }
    };
    return (
        <Grid container>
            {/* {typeof profile.networkRequest !== 'undefined' &&
                profile.networkRequest.status === 'pending' && (
                    <NetworkRequest
                        networkRequest={profile.networkRequest}
                        network={'school'}
                    />
                )} */}

            {props.networkPermission ? (
                <>
                    {school.networkDetails?.network?.status === 'accepted' ? (
                        <Typography
                            variant="h3"
                            sx={{
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                            }}
                        >
                            Network Name:{' '}
                            {school.networkDetails.network['gs1-pk']}
                        </Typography>
                    ) : (
                        <form onSubmit={handleFormSubmit}>
                            <Typography
                                variant="h3"
                                sx={{ textAlign: 'left', marginBottom: '8px' }}
                            >
                                Create a new network
                            </Typography>
                            <Typography>
                                A school network allows you to share teachers
                                amongst your local schools. Once a school is
                                part of a network it will be able to book other
                                teachers from that network. CRT's that create
                                vacancies in their schedule who are part of this
                                network will only show up for that network of
                                schools.
                            </Typography>
                            <GeneralText
                                id="networkName"
                                data-cy="networkName"
                                label="Create a school network"
                                variant="outlined"
                                placeholder="Enter a name for your new network"
                                value={networkName}
                                onChange={changeNetworkName}
                                onKeyDown={handleKeyDown}
                            />
                            <BookingButton
                                id="createNetwork"
                                data-cy="create-network"
                                size="large"
                                color="primary"
                                onClick={event => {
                                    createNetwork(event);
                                }}
                                loading={loading}
                                loadingPosition="start"
                                startIcon={<SaveIcon />}
                                variant="outlined"
                                disabled={createNetworkDisabled}
                            >
                                Save
                            </BookingButton>
                        </form>
                    )}
                </>
            ) : (
                <Box>
                    <Typography>
                        You do not have access to the network feature.
                    </Typography>
                    <Typography>
                        Please upgrade your{' '}
                        <Link to="/profile/billing">subscription</Link> to the
                        Premium Subscription to access the network feature.
                    </Typography>
                </Box>
            )}
            {/* {typeof profile.network !== 'undefined' &&
                profile.network.status === 'pending' && (
                    <NetworkRequest
                        networkRequest={{
                            name: profile.network.school,
                            from: profile.network.school,
                            status: profile.network.status,
                        }}
                        network={'teacher'}
                    />
                )} */}
            {props.networkPermission &&
                profile.role === 'admin' &&
                typeof school.networkDetails?.network?.pk1 !== 'undefined' && (
                    <>
                        {school.networkDetails.network.status === 'pending' && (
                            <NetworkRequest profile={profile} />
                        )}
                        {(school.networkDetails.network.status === 'accepted' ||
                            profile.network[0].status === 'accepted') && (
                            <NetworkSchool
                                network={school.networkDetails}
                                pk1={profile['gs1-pk']}
                                crtList={school.crtList}
                                teacherList={school.teacherList}
                                profile={profile}
                            />
                        )}
                    </>
                )}

            {typeof profile.network !== 'undefined' &&
                profile.network.map(ntwrk => {
                    if (
                        ntwrk.length > 0 &&
                        ntwrk.some(obj => obj.status === 'pending') &&
                        ntwrk.role === 'admin'
                        //ntwrk.role !== 'admin'
                    ) {
                        return <NetworkRequest profile={profile} />;
                    }
                })}
        </Grid>
    );
};

export default Network;
